import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#16171a] border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-primary to-accent rounded-xl flex items-center justify-center">
                <i className="ri-image-ai-line text-2xl text-white"></i>
              </div>
              <span className="text-xl font-black text-white">AnyPicAI</span>
            </div>
            <p className="text-base text-gray-400 font-semibold max-w-md mb-6">
              {t('footer.description')}
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 bg-[#252830] hover:bg-primary border border-gray-700 hover:border-primary rounded-full flex items-center justify-center text-gray-400 hover:text-white transition-all cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-[#252830] hover:bg-primary border border-gray-700 hover:border-primary rounded-full flex items-center justify-center text-gray-400 hover:text-white transition-all cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-[#252830] hover:bg-primary border border-gray-700 hover:border-primary rounded-full flex items-center justify-center text-gray-400 hover:text-white transition-all cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-[#252830] hover:bg-primary border border-gray-700 hover:border-primary rounded-full flex items-center justify-center text-gray-400 hover:text-white transition-all cursor-pointer">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-black text-white mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-primary font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/generator" className="text-sm text-gray-400 hover:text-primary font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  {t('nav.generator')}
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-sm text-gray-400 hover:text-primary font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  {t('nav.pricing')}
                </Link>
              </li>
              <li>
                <Link to="/member" className="text-sm text-gray-400 hover:text-primary font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  {t('nav.member')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-base font-black text-white mb-4">{t('footer.support')}</h3>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-primary font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.help')}
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-primary font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.faq')}
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-primary font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.contact')}
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-400 hover:text-primary font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  {t('footer.privacy')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500 font-semibold">
            © {currentYear} AnyPicAI. {t('footer.rights')}
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-gray-500 hover:text-primary font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
